<template>
	<div class="page">
		<div class="posiR">
			<div class="posiRItem" :class="[curBusiness=='rBingli'?'active':'']" @click="changeCurBusiness('rBingli')">
				待完成病例
				<span class="num">{{rightBingliParams.num}}</span>
			</div>
			<div class="posiRItem" :class="[curBusiness=='rYmqc'?'active':'']" @click="changeCurBusiness('rYmqc')">
				待完成疫苗驱虫
				<span class="num">{{rightYmqcParams.num}}</span>
			</div>
			<div class="posiRItem" :class="[curBusiness=='rZhuyuan'?'active':'']" @click="changeCurBusiness('rZhuyuan')">
				待出院
				<span class="num">{{rightZhuyuanParams.num}}</span>
			</div>
		</div>
		<div class="tabLine">
			<div class="tabLineSearch">
				<el-select
					v-if="canChangeCurMember"
					style="width:300px;"
					class="yiliaoxinCustomStyleMark"
					size="medium"
					v-model="keyword"
					placeholder="请输入顾客手机号"
					filterable
					remote
					@change="changeMember"
					:remote-method="remoteMethodMember"
				>
					<div slot="prefix">
						<img src="../../../assets/img/yiliaoxin/search.png" style="padding-top:8px;padding-left:10px;font-size: 20px;width:20px;"/>
						<!-- <i class="el-icon-search" ></i> -->
					</div>
					<el-option
					v-for="(item) in vipList" :key="item._id"
					:label="(
					!item.club_card||item.club_card. surplus_day==0?
					'':
					'['+item.club_card.surplus_day+'天]'
					)+
					item.basic_info.nick_name+(item.basic_info.user_mobile?' ('+item.basic_info.user_mobile+')':'(无手机号)')"
					:value="item._id">
					</el-option>
					<template slot="empty">
						<div style="width:300px;font-size: 14px;color:red;text-align: center;padding:10px 0;">没有客户信息，请创建客户档案</div>
					</template>
				</el-select>
			</div>
			<div class="tabBox">
				<!-- <div class="tabItem" :class="[curBusiness==='工作台'?'active':'']" @click="aaa">aaaaaaa</div> -->
				<div class="tabItem" :class="[curBusiness==='工作台'?'active':'']" @click="changeCurBusiness('工作台')">工作台</div>
				<div class="tabItem" v-if="$buttonAuthority('yewu-yiliaoxin-tabItem1')" :class="[curBusiness==='挂号'?'active':'']" @click="changeCurBusiness('挂号')">挂号</div>
				<div class="tabItem" v-if="$buttonAuthority('yewu-yiliaoxin-tabItem2')" :class="[curBusiness==='接诊'?'active':'']" @click="changeCurBusiness('接诊')">接诊</div>
				<div class="tabItem" v-if="$buttonAuthority('yewu-yiliaoxin-tabItem3')" :class="[curBusiness==='病例'?'active':'']" @click="changeCurBusiness('病例')">病例</div>
				<div class="tabItem" v-if="$buttonAuthority('yewu-yiliaoxin-tabItem4')" :class="[curBusiness==='疫苗驱虫'?'active':'']" @click="changeCurBusiness('疫苗驱虫')">疫苗驱虫</div>
				<div class="tabItem" v-if="$buttonAuthority('yewu-yiliaoxin-tabItem5')" :class="[curBusiness==='医疗服务'?'active':'']" @click="changeCurBusiness('医疗服务')">医疗服务</div>
				<div class="tabItem" v-if="$buttonAuthority('yewu-yiliaoxin-tabItem6')" :class="[curBusiness==='住院'?'active':'']" @click="changeCurBusiness('住院')">住院</div>
				<div class="tabItem" v-if="$buttonAuthority('yewu-yiliaoxin-tabItem7')" :class="[curBusiness==='药房'?'active':'']" @click="changeCurBusiness('药房')">药房</div>
			</div>
		</div>
		<div>
			<panelTop></panelTop>
		</div>
		<panelPlatform v-if="curBusiness=='工作台'"></panelPlatform>
		<panelGuahao v-if="curBusiness=='挂号'"></panelGuahao>
		<panelJiezhen v-if="curBusiness=='接诊'"></panelJiezhen>
		<panelYmqc v-if="curBusiness=='疫苗驱虫'"></panelYmqc>
		<panelYlfw v-if="curBusiness=='医疗服务'"></panelYlfw>
		<panelBingli v-if="curBusiness=='病例'"></panelBingli>
		<panelZhuyuan v-if="curBusiness=='住院'"></panelZhuyuan>
		<panelYaofang v-if="curBusiness=='药房'"></panelYaofang>
		<rBingli v-if="curBusiness=='rBingli'"></rBingli>
		<rYmqc v-if="curBusiness=='rYmqc'"></rYmqc>
		<rZhuyuan v-if="curBusiness=='rZhuyuan'"></rZhuyuan>
		<rJiezhenDai v-if="curBusiness=='rJiezhenDai'"></rJiezhenDai>
		<rJiezhenZhong v-if="curBusiness=='rJiezhenZhong'"></rJiezhenZhong>
	</div>
</template>
<script>
	import panelTop from "./panel_top.vue"
	import panelPlatform from "./panel/platform.vue"
	import panelGuahao from "./panel/guahao.vue"
	import panelJiezhen from "./panel/jiezhen.vue"
	import panelYmqc from "./panel/ymqc.vue"
	import panelYlfw from "./panel/ylfw.vue"
	import panelBingli from "./panel/bingli.vue"
	import panelZhuyuan from "./panel/zhuyuan.vue"
	import panelYaofang from "./panel/yaofang.vue"
	import rBingli from "./panel/rBingli.vue"
	import rYmqc from "./panel/rYmqc.vue"
	import rZhuyuan from "./panel/rZhuyuan.vue"
	import rJiezhenDai from "./panel/rJiezhenDai.vue"
	import rJiezhenZhong from "./panel/rJiezhenZhong.vue"
	export default {
		components:{panelTop,panelPlatform,panelGuahao,panelJiezhen,panelYmqc,panelYlfw,panelBingli,panelZhuyuan,panelYaofang,rBingli,rYmqc,rZhuyuan,rJiezhenDai,rJiezhenZhong},
		data(){
			return{
				keyword:'',
				vipList:[],
				
			}
		},
		computed:{
			curBusiness(){
				return this.$store.state.yiliaoxin.curBusiness;
			},
			platformParams(){
				return this.$store.state.yiliaoxin.platformParams;
			},
			rightBingliParams(){
				return this.$store.state.yiliaoxin.rightBingliParams;
			},
			rightYmqcParams(){
				return this.$store.state.yiliaoxin.rightYmqcParams;
			},
			rightZhuyuanParams(){
				return this.$store.state.yiliaoxin.rightZhuyuanParams;
			},
			canChangeCurMember(){
				return this.$store.getters["yiliaoxin/canChangeCurMember"]
			},
		},
		watch:{
		},
		mounted(){
			this.$store.dispatch("yiliaoxin/get_NotMedicalCount")
		},
		methods: {
			aaa(){
				console.log(this.$store.state.yiliaoxin.router)
			},
			changeCurBusiness(str){
				if(str==='工作台'){
					this.$store.state.yiliaoxin.platformParams.type='list'
					this.$store.commit("yiliaoxin/set_platformParams",this.$store.state.yiliaoxin.platformParams)
					this.$store.commit("yiliaoxin/add_router",{name:str,data:this.$store.state.yiliaoxin.platformParams})
				}else if(str==='接诊'){
					this.$store.state.yiliaoxin.jiezhenParams.type='list'
					this.$store.commit("yiliaoxin/set_jiezhenParams",this.$store.state.yiliaoxin.jiezhenParams)
					this.$store.commit("yiliaoxin/add_router",{name:str,data:this.$store.state.yiliaoxin.jiezhenParams})
				}else if(str==='病例'){
					this.$store.state.yiliaoxin.bingliParams.type='list'
					this.$store.commit("yiliaoxin/set_bingliParams",this.$store.state.yiliaoxin.bingliParams)
					this.$store.commit("yiliaoxin/add_router",{name:str,data:this.$store.state.yiliaoxin.bingliParams})
				}else if(str==='疫苗驱虫'){
					this.$store.state.yiliaoxin.ymqcParams.type='list'
					this.$store.commit("yiliaoxin/set_ymqcParams",this.$store.state.yiliaoxin.ymqcParams)
					this.$store.commit("yiliaoxin/add_router",{name:str,data:this.$store.state.yiliaoxin.ymqcParams})
				}else if(str==='医疗服务'){
					this.$store.state.yiliaoxin.ylfwParams.type='list'
					this.$store.commit("yiliaoxin/set_ylfwParams",this.$store.state.yiliaoxin.ylfwParams)
					this.$store.commit("yiliaoxin/add_router",{name:str,data:this.$store.state.yiliaoxin.ylfwParams})
				}else if(str==='住院'){
					this.$store.state.yiliaoxin.zhuyuanParams.type='list'
					this.$store.commit("yiliaoxin/set_zhuyuanParams",this.$store.state.yiliaoxin.zhuyuanParams)
					this.$store.commit("yiliaoxin/add_router",{name:str,data:this.$store.state.yiliaoxin.zhuyuanParams})
				}else if(str==='药房'){
					this.$store.state.yiliaoxin.yaofangParams.type='list'
					this.$store.commit("yiliaoxin/set_yaofangParams",this.$store.state.yiliaoxin.yaofangParams)
					this.$store.commit("yiliaoxin/add_router",{name:str,data:this.$store.state.yiliaoxin.yaofangParams})
				}
				this.$store.commit('yiliaoxin/set_curBusiness',str)
			},
			// 选择顾客
			changeMember(id){
				let userInfo = this.vipList.filter(item => {return item._id == id})[0]
				this.$store.commit('yiliaoxin/set_userInfo',userInfo)
				this.$util.getControllerForMember(id).then(res=>{
					this.$store.commit('yiliaoxin/set_userController',res)
				})
				// 获取用户可用的优惠券列表
				this.$store.commit("yiliaoxin/set_curPetId",userInfo.pets_info[0]?userInfo.pets_info[0]._id:'')
				this.$store.dispatch("yiliaoxin/get_danganNumber",userInfo.pets_info[0]?userInfo.pets_info[0]._id:'')
				this.$store.dispatch("yiliaoxin/get_couponList",id);
				this.vipList=[];
				this.keyword='';
			},
			remoteMethodMember(str){
				this.$util.getVipList(str).then(list=>{
					this.vipList = list
				})
			},
		}
	}
</script>
<style scoped lang="scss">
.page{
	width:100%;height: 100%;position: relative;padding:0 40px 0 6px;box-sizing: border-box;
	.posiR{
		position: absolute;right: -10px;top:145px;z-index: 50;
		.posiRItem{
			background-color: #fff;width:40px;padding:10px 12px;box-sizing: border-box;font-size: 12px;text-align: center;line-height: 18px;border-radius: 12px 0 0 12px;cursor: pointer;margin-bottom:10px;
			.num{
				color:#5E7BFA;font-size: 16px;
			}
			&.active{
				background-color: #5E7BFA;color:#fff;
				.num{
					color:#fff;
				}
			}
		}
	}
	.tabLine{
		display: flex;justify-content: space-between;
		.tabLineSearch{
			
		}
		.tabBox{
			height: 40px;border-radius: 20px;background-color: #edeef2;padding:4px 0;box-sizing: border-box;display: flex;
			.tabItem{
				width:90px;line-height: 32px;border-radius: 16px;text-align: center;font-size: 12px;color:$fontColor;cursor: pointer;margin:0 4px;font-weight: bold;
				&.active{
					background-color: $mainColor;color:#fff;
				}
			}
		}
	}
}
.yiliaoxinCustomStyleMark{
	::v-deep .el-input__inner{
		border-radius: 18px;
		padding-left:40px;
	}
}
</style>
